module.exports = "<p>\r\n  cbs-icon works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/cbs-icon/cbs-icon.component.html
// module id = ./src/app/shared/cbs-icon/cbs-icon.component.html
// module chunks = main